import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { LogoWordmark } from "@/components/Logo";
import WalletButton from "@/components/WalletButton";

const LINKS = [
  { href: "/", label: "Swap" },
  { href: "/#markets", label: "Markets" },
  { href: "/#activity", label: "Activity" },
  { href: "/#networks", label: "Networks" },
  { href: "https://decentralizedexchange.gitbook.io/docs", label: "Docs", external: true },
];

export default function Navbar() {
  const [openMobile, setOpenMobile] = useState(false);
  const loc = useLocation();
  const isActive = (href) => {
    if (href.startsWith("/#")) return loc.pathname === "/";
    return loc.pathname === href;
  };
  return (
    <header className="sticky top-0 z-40 border-b border-[var(--border)] bg-[rgba(255,255,255,0.75)] backdrop-blur-xl">
      <div className="max-w-[1440px] mx-auto px-3 sm:px-5 lg:px-8 h-16 flex items-center justify-between gap-2">
        <div className="flex items-center gap-3 sm:gap-8 min-w-0">
          <Link to="/" className="flex items-center" data-testid="nav-logo">
            <LogoWordmark />
          </Link>
          <nav className="hidden md:flex items-center gap-1 text-[13px]">
            {LINKS.map((l) =>
              l.external ? (
                <a key={l.label} href={l.href} target="_blank" rel="noopener noreferrer"
                  className="px-3 h-9 inline-flex items-center rounded-lg text-[var(--text-muted)] hover:text-[var(--text)] hover:bg-[var(--panel-2)]"
                  data-testid={`nav-link-${l.label.toLowerCase()}`}>
                  {l.label}
                </a>
              ) : l.href.startsWith("/#") ? (
                <a key={l.label} href={l.href}
                  className={`px-3 h-9 inline-flex items-center rounded-lg ${
                    isActive(l.href) ? "text-[var(--text)] bg-[var(--panel-2)]" : "text-[var(--text-muted)] hover:text-[var(--text)] hover:bg-[var(--panel-2)]"
                  }`}
                  data-testid={`nav-link-${l.label.toLowerCase()}`}>
                  {l.label}
                </a>
              ) : (
                <Link key={l.label} to={l.href}
                  className={`px-3 h-9 inline-flex items-center rounded-lg ${
                    isActive(l.href) ? "text-[var(--text)] bg-[var(--panel-2)]" : "text-[var(--text-muted)] hover:text-[var(--text)] hover:bg-[var(--panel-2)]"
                  }`}
                  data-testid={`nav-link-${l.label.toLowerCase()}`}>
                  {l.label}
                </Link>
              )
            )}
          </nav>
        </div>
        <div className="flex items-center gap-1.5 sm:gap-2">
          <WalletButton />
          <button
            className="md:hidden w-10 h-10 rounded-lg text-[var(--text-muted)] hover:text-[var(--text)] hover:bg-[var(--panel-2)] flex items-center justify-center"
            onClick={() => setOpenMobile((v) => !v)}
            aria-label="Menu"
          >
            {openMobile ? <X size={16} /> : <Menu size={16} />}
          </button>
        </div>
      </div>
      {openMobile && (
        <div className="md:hidden border-t border-[var(--border)] bg-[var(--panel)]">
          <nav className="max-w-[1440px] mx-auto px-3 py-2 flex flex-col">
            {LINKS.map((l) => (
              <a key={l.label} href={l.href}
                {...(l.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                onClick={() => setOpenMobile(false)}
                className="px-3 h-11 flex items-center rounded-lg text-[13px] text-[var(--text-muted)] hover:text-[var(--text)] hover:bg-[var(--panel-2)]">
                {l.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
